module.exports = "https://cdn.hellotech.com/client-assets/home-front-desktop_90b2d500abb2b30eb0b72836416737aa.jpg";